module.exports = __webpack_public_path__ + "img/profitable-img-mobile-1.5f2679c4.png";